export const one_purchaser_signers = ['Client', 'Admin', 'Builder'];
export const two_purchaser_signers = [
	'Client',
	'Second Purchaser',
	'Admin',
	'Builder',
];

export const one_purchaser_signers_condo_docs = ['Client'];
export const two_purchaser_signers_condo_docs = ['Client', 'Second Purchaser'];
